(ns frontend.view.curtains.webentry-resolution.events
  (:require [frontend.view.curtains.webentry-resolution.db :as db :refer [state]]
            [common.localization :as loc]
            [frontend.state.current-session :as current-session]
            [frontend.logging :as logging]
            [common.fields.schema :as fields]
            [frontend.state.current-session :as session]
            [common.util :as cu]))

(defn open? []
  (:open? @state))

(defn open-curtain! [task v3?]
  (let [we-settings (->> @session/all-webentries
                         (remove :common/disabled?)
                         (filter (fn [we]
                                   (= (:webentry/display-name we)
                                      (or (:task/source task) "Primary"))))
                         (map (fn [we]
                                (let [fs (if v3? (->> we
                                                      :webentry/field-config
                                                      (mapcat (fn [[entity entity-config]]
                                                                (:selected-fields entity-config)))
                                                      (map (fn [attr]
                                                             [attr :in-use]))
                                                      (into {})
                                                      (fields/webentry-settings))
                                                 (->> we
                                                      :webentry/field-settings
                                                      (fields/webentry-settings)))]
                                  fs
                                  )))
                         (first))]
    (when (current-session/is-mobile?)
      (.scrollTo js/window 0 0))

    (swap! state assoc
           :open? true
           :field-settings we-settings)))

(defn close-curtain! []
  (db/clear!))

(defn set-alert! [text]
  (swap! state assoc :alert (or (str text) (loc/tr :failed))))

(defn hide-alert! []
  (swap! state dissoc :alert))

(defn on-error! [e]
  (logging/error "webentry resolution failed:" e)
  (let [data (-> e ex-data)
        error (-> data :error)
        msg (-> data :message)
        message (cond (string? msg)
                      msg
                      (keyword? msg)
                      (loc/tr msg)
                      :else
                      nil)]
    (if message
      (set-alert! message)
      (set-alert! (loc/tr error)))))
